import * as React from 'react';
import 'react-quill/dist/quill.bubble.css';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';

const RichTextEditor = (props) => {

    const onChange = (e) => {
        let arg = {
            currentTarget: {
                name: props.name,
                value: e === '<p><br></p>' ? '' : e
            }
        }
        if (props.onChange) {
            props.onChange(arg);
        }
    }

    const modules = {
        toolbar: [
            // [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
            ["image"],
            ["clean"],
        ]
    }

    return (
        <ReactQuill
            id={props.id}
            modules={modules}
            theme={props.readOnly ? "bubble" : "snow"}
            readOnly={props.readOnly}
            value={props.value}
            placeholder={props.placeholder}
            onBlur={props.onBlur}
            onChange={onChange} />
    );
};

export default RichTextEditor;